import { Component } from '@angular/core';

import { environment } from '@env/environment';
import { HeaderComponent } from '@theme/header/header.component';

import { BotUiConfigSettingsComponent } from './components/bot-ui-config-settings/bot-ui-config-settings.component';
import { CountriesAllowedComponent } from './components/countries-allowed/countries-allowed.component';
import { DashboardContentComponent } from './components/dashboard-content/dashboard-content.component';
import { ExitSurveyComponent } from './components/exit-survey/exit-survey.component';
import { GlobalInstructionsComponent } from './components/global-instructions/global-instructions.component';
import { GlobalVocabularyRulesComponent } from './components/global-vocabulary-rules/global-vocabulary-rules.component';
import { LoginNoticeComponent } from './components/login-notice/login-notice.component';
import { LoginPopupComponent } from './components/login-popup/login-popup.component';
import { ReferenceCitationDisplayComponent } from './components/reference-citation-display/reference-citation-display.component';
import { ReferenceStreamModeComponent } from './components/reference-stream-mode/reference-stream-mode.component';
import { VersionComponent } from './components/version/version.component';
import {
  ContentShellComponent,
  ListItemComponent,
  PanelHeaderComponent,
} from '@shared/components/content-panel';

interface SettingsItem {
  id: string;
  label: string;
}

@Component({
  selector: 'app-app-settings',
  templateUrl: './app-settings.component.html',
  styleUrls: ['./app-settings.component.scss'],
  imports: [
    ContentShellComponent,
    HeaderComponent,
    PanelHeaderComponent,
    ListItemComponent,
    CountriesAllowedComponent,
    GlobalVocabularyRulesComponent,
    GlobalInstructionsComponent,
    DashboardContentComponent,
    LoginNoticeComponent,
    VersionComponent,
    LoginPopupComponent,
    ExitSurveyComponent,
    BotUiConfigSettingsComponent,
    ReferenceStreamModeComponent,
    ReferenceCitationDisplayComponent,
  ],
})
export class AppSettingsComponent {
  protected selectedItem = 'countries';

  protected settingsItems: SettingsItem[] = [
    { id: 'countries', label: 'Countries' },
    { id: 'vocabulary', label: 'Global Static Instruction' },
    { id: 'instructions', label: 'Global Dynamic Instructions' },
    { id: 'dashboard', label: 'Dashboard Content' },
    { id: 'login-notice', label: 'Login Notice' },
    { id: 'version', label: 'Version' },
    { id: 'login-popup', label: 'Login Popup' },
    { id: 'exit-survey', label: 'Exit Survey' },
    { id: 'bot-ui-config', label: 'Bot UI configuration' },
    { id: 'reference-stream-mode', label: 'Reference stream mode' },
    ...(environment.referenceDisplayModeSettingEnabled
      ? [{ id: 'reference-citation-display', label: 'Reference display mode' } as SettingsItem]
      : []),
  ];

  protected selectItem(itemId: string): void {
    this.selectedItem = itemId;
  }
}
